import { AiPromptSchema } from '@ametista-ai/api-schema';
import { ApiPaginatedResponse, isOffsetPagination } from '@ametista-ai/api-schema/http/types';
import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/stores/api/apiClient';
import { aiPromptsKeys } from './keys';

const PAGE_LIMIT = 100;
const REFETCH_INTERVAL_MS = 60 * 1000;

function fetchPage(offset: number) {
  return apiClient.get<ApiPaginatedResponse<AiPromptSchema>>('/v1/ai/history', {
    limit: PAGE_LIMIT,
    offset,
  });
}

export function useAiPromptHistory() {
  return useQuery({
    queryKey: aiPromptsKeys.list(),
    queryFn: async () => {
      const firstPage = await fetchPage(0);

      const total =
        firstPage.pagination && isOffsetPagination(firstPage.pagination)
          ? firstPage.pagination.total
          : firstPage.data.length;
      const pageCount = Math.ceil(total / PAGE_LIMIT);

      const remainingPages = await Promise.all(
        Array.from({ length: Math.max(pageCount - 1, 0) }, (_, i) =>
          fetchPage((i + 1) * PAGE_LIMIT)
        )
      );

      return [...firstPage.data, ...remainingPages.flatMap((page) => page.data)];
    },
    refetchInterval: REFETCH_INTERVAL_MS,
  });
}
